import './Icon.scss';
import Component from './Icon.js';
export default Component;
